document.addEventListener("alpine:init", () => {
  // Helper function to format money using Shopify's money format
  function formatMoney(cents, format) {
    let formatted = "";
    if (Shopify?.formatMoney) {
      formatted = Shopify.formatMoney(cents, format);
      // Strip HTML tags if Shopify.formatMoney returns HTML (e.g., <span class=money>$34.95</span>)
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = formatted;
      return tempDiv.textContent || tempDiv.innerText || formatted;
    }

    // Fallback formatter if Shopify.formatMoney is not available
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    cents = parseInt(cents, 10);

    if (isNaN(cents) || cents == null) {
      return "0.00";
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "{{amount}}";
    const match = formatString.match(placeholderRegex);

    if (!match) {
      return (cents / 100).toFixed(2);
    }

    const amountType = match[1];
    let value = "";
    const precision = 2;
    const thousands = ",";
    const decimal = ".";

    const number = (cents / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands,
    );
    const centsPart = parts[1] ? decimal + parts[1] : "";

    switch (amountType) {
      case "amount":
        value = dollars + centsPart;
        break;
      case "amount_no_decimals":
        value = dollars;
        break;
      case "amount_with_comma_separator":
        value =
          parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ".") +
          "," +
          parts[1];
        break;
      case "amount_no_decimals_with_comma_separator":
        value = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ".");
        break;
      default:
        value = dollars + centsPart;
    }

    formatted = formatString.replace(placeholderRegex, value);
    // Strip HTML tags from fallback formatter result too (format string might contain HTML)
    const tempDiv2 = document.createElement("div");
    tempDiv2.innerHTML = formatted;
    return tempDiv2.textContent || tempDiv2.innerText || formatted;
  }

  // --- INSTANT DATA HELPER ---
  // Returns data from memory (0ms) if available,
  // otherwise fetches once and saves it.
  async function getProductData(handle) {
    if (window.productDataCache && window.productDataCache[handle]) {
      return window.productDataCache[handle];
    }
    try {
      const response = await fetch(
        window.Shopify.routes.root + `products/${handle}.js`,
      );
      const data = await response.json();
      window.productDataCache = window.productDataCache || {};
      window.productDataCache[handle] = data;
      return data;
    } catch (e) {
      console.error("Error fetching product data", e);
      return null;
    }
  }

  Alpine.data("mainProduct", (element, sectionID) => ({
    init() {
      this.stickyATC = false;
      this.currentVariantId = Number(element.dataset.currentVariantId);
      this.currentVariantTitle = element.dataset.currentVariantTitle;
      this.currentVariantPrice = element.dataset.currentVariantPrice;
      this.currentVariantCompareAtPrice =
        element.dataset.currentVariantCompareAtPrice;
      this.handle = element.dataset.productHandle;
      this.productGallery =
        document.querySelector("#product-gallery").innerHTML;
      this.selectedQuantity = 3;
      this.freeGiftId = Number(element.dataset.freeGiftId);
      this.totalPrice = "";
      this.productOne = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productTwo = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productThree = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      // Filter slides for the initial variant before initializing Swiper
      this.updateSliderImages(this.currentVariantId);
      // Use timeout to ensure DOM is ready, matching variant selection flow
      setTimeout(() => {
        this.initSlider();
        // Force Swiper to update after initialization to ensure pagination renders
        if (this.main && this.main.update) {
          this.main.update();
        }
      }, 200);
      this.initVideoPlay();
      this.initVideoSlider();

      // Hide gallery spinners on initial load
      this._initSpinnerHideTimeout = setTimeout(() => {
        const el = document.querySelector("#product-gallery");
        if (el) {
          el.querySelectorAll(".loading-spinner").forEach((s) => {
            s.style.display = "none";
          });
        }
        this._initSpinnerHideTimeout = null;
      }, 100);
    },

    initSlider() {
      // Destroy existing Swiper instances if they exist
      if (this.main && this.main.destroy) {
        this.main.destroy(true, true);
      }
      if (this.thumbs && this.thumbs.destroy) {
        this.thumbs.destroy(true, true);
      }

      if (window.innerWidth > 999) {
        this.thumbs = new Swiper(this.$refs.sliderThumbs, {
          slidesPerView: "auto",
          spaceBetween: 8,
          mousewheel: {
            releaseOnEdges: true,
          },
        });
      }
      this.main = new Swiper(this.$refs.sliderMain, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        thumbs: {
          swiper: this.thumbs,
        },
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
          dynamicBullets: false,
        },
        navigation: {
          nextEl: document.querySelector(".swiper-button-prev-custom"),
          prevEl: document.querySelector(".swiper-button-next-custom"),
        },
        breakpoints: {
          1000: {
            pagination: false,
          },
        },
        on: {
          init: function () {
            // Force pagination update on init
            if (this.pagination && this.pagination.el) {
              this.pagination.render();
              this.pagination.update();
            }
          },
        },
      });
    },

    updateSliderImages(variantId) {
      const slides = document.querySelectorAll(".swiper-slide[variant-id]");

      slides.forEach((slide) => {
        if (Number(slide.getAttribute("variant-id")) !== variantId) {
          slide.remove();
        }
      });
    },
    async fetchGallery() {
      const productGallery = document.querySelector("#product-gallery");
      if (!productGallery) return;

      // Clear any previous hide timeout and init hide timeout
      if (this._gallerySpinnerHideTimeout != null) {
        clearTimeout(this._gallerySpinnerHideTimeout);
        this._gallerySpinnerHideTimeout = null;
      }
      if (this._initSpinnerHideTimeout != null) {
        clearTimeout(this._initSpinnerHideTimeout);
        this._initSpinnerHideTimeout = null;
      }

      const galleryHeight = productGallery.offsetHeight;
      productGallery.style.height = `${galleryHeight}px`;

      productGallery.innerHTML = this.productGallery;

      this._gallerySpinnerHideTimeout = setTimeout(() => {
        // Hide spinners first (scoped to gallery only)
        productGallery
          .querySelectorAll(".loading-spinner")
          .forEach((spinner) => {
            spinner.style.display = "none";
          });

        // Then clear height (in try/catch so hide always runs even if this throws)
        try {
          productGallery.style.height = "";
        } catch (_) {}

        this._gallerySpinnerHideTimeout = null;
      }, 2000);
    },

    updateTheThreeProducts(title) {
      const inputEls = document.querySelectorAll(
        `#but2get1 input[value="${title}"]`,
      );

      inputEls.forEach((el) => {
        el.checked = true;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },

    updateSticky(title) {
      if (Alpine.store("sync").isSyncing) return;
      Alpine.store("sync").isSyncing = true;

      const stickyInput = document.querySelector(
        `#stickyATC input[value="${title}"]`,
      );

      stickyInput.checked = true;
      stickyInput.dispatchEvent(new Event("change", { bubbles: false }));

      Alpine.store("sync").isSyncing = false;
    },
    handleCheckboxChange() {
      this.updateTotalPrice();
    },

    updateTotalPrice() {
      if (this.selectedQuantity === 1) {
        this.totalPrice = this.currentVariantPrice;
      }
      if (this.selectedQuantity === 3) {
        this.totalPrice = this.productOne.price + this.productTwo.price;
      }
    },

    initVideoPlay() {
      const videoWrappers = document.querySelectorAll(
        ".video-wrapper, .video-wrapper-new",
      );
      if (!videoWrappers.length) return;

      videoWrappers.forEach(function (videoWrapper) {
        const posterImageWrapper = videoWrapper.querySelector(
          ".poster-image-wrapper, .poster-image-wrapper-new",
        );
        const videoElement = videoWrapper.querySelector("video");

        if (posterImageWrapper && videoElement) {
          // 1. Handle Poster Click
          posterImageWrapper.addEventListener("click", function (e) {
            e.stopPropagation();

            // Hide poster
            posterImageWrapper.style.opacity = "0";
            posterImageWrapper.style.pointerEvents = "none";

            // Show/Play video
            videoElement.classList.remove("hidden");
            videoElement.style.opacity = "1";
            videoElement.controls = true; // Ensure controls are active
            videoElement.play();
          });

          // 2. DISABLE Pausing/Playing on Video Surface Click
          videoElement.addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault(); // This stops the video from pausing when you tap it
          });

          // 3. Stop Focus Event Bubbling (prevents Swiper jumps)
          videoElement.addEventListener("focus", function (e) {
            e.preventDefault();
            e.stopPropagation();
          });

          // 4. Sync Poster State on Play/Pause
          videoElement.addEventListener("play", function () {
            posterImageWrapper.style.opacity = "0";
            posterImageWrapper.style.pointerEvents = "none";
          });

          videoElement.addEventListener("pause", function () {
            if (videoElement.currentTime === 0 || videoElement.ended) {
              posterImageWrapper.style.opacity = "1";
              posterImageWrapper.style.pointerEvents = "auto";
              videoElement.controls = false;
            }
          });
        }
      });
    },

    initVideoSlider() {
      const videoConfig = {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,

        // --- CRITICAL FIXES FOR CAROUSEL JUMPING ---
        a11y: false,
        slideToClickedSlide: false,
        preventClicks: false,
        preventClicksPropagation: false,
        observer: false,
        observeParents: false,
      };

      if (this.$refs.videoSlider) {
        this.videoSlider = new Swiper(this.$refs.videoSlider, videoConfig);
      }

      if (this.$refs.videoSliderDesktop) {
        this.videoSliderDesktop = new Swiper(
          this.$refs.videoSliderDesktop,
          videoConfig,
        );
      }
    },
  }));

  Alpine.data("productOptions", (element, handle) => ({
    init() {
      this.findMatchingVariant();
      // Sync sticky color dropdown on page load (wait for sticky ATC to render)
      setTimeout(() => {
        this.syncStickyColorDropdownFromMainOptions();
      }, 300);
    },

    // Sync sticky ATC color dropdown based on currently selected color in main options
    syncStickyColorDropdownFromMainOptions() {
      // Check if sticky ATC exists, if not retry after a short delay
      const stickyATC = document.getElementById("stickyATC");
      if (!stickyATC) {
        setTimeout(() => {
          this.syncStickyColorDropdownFromMainOptions();
        }, 200);
        return;
      }

      // Get currently selected color from main product options
      const checkedRadios = element.querySelectorAll(
        'input[type="radio"]:checked',
      );
      if (checkedRadios.length === 0) return;

      // First option is color
      const colorValue = checkedRadios[0]?.value;
      if (!colorValue) return;

      this.syncStickyColorDropdown(colorValue);
    },

    // Sync sticky ATC color dropdown with a specific color value
    syncStickyColorDropdown(colorValue) {
      const stickyATC = document.getElementById("stickyATC");

      if (!stickyATC || !colorValue) return;

      // Find the radio input matching the color value first
      const colorRadioInput = stickyATC.querySelector(
        `input[type="radio"][value="${colorValue}"]`,
      );

      if (colorRadioInput) {
        // Find the Alpine component container (parent div with x-data)
        let colorDropdownContainer = colorRadioInput.closest("[x-data]");

        // If not found via radio input, try finding by the selected value display
        if (!colorDropdownContainer) {
          const selectedValueDisplay = stickyATC.querySelector(
            '[x-text*="selected.value"]',
          );
          if (selectedValueDisplay) {
            colorDropdownContainer = selectedValueDisplay.closest("[x-data]");
          }
        }

        if (colorDropdownContainer) {
          // Get the swatch image URL from the img element in the same label
          const label = colorRadioInput.closest("label");
          const imgElement = label ? label.querySelector("img") : null;
          const imageUrl = imgElement ? imgElement.src : null;

          // Access the Alpine component data
          const alpineData = Alpine.$data(colorDropdownContainer);

          if (alpineData && alpineData.selected) {
            // Update the selected color and image
            alpineData.selected.value = colorValue;
            if (imageUrl) {
              alpineData.selected.image = imageUrl;
            }

            // Check the radio input to sync the visual state
            colorRadioInput.checked = true;

            console.log("✅ Synced sticky ATC color dropdown:", {
              color: colorValue,
              image: imageUrl,
            });
          }
        }
      }
    },

    async findMatchingVariant() {
      console.log("🔍 Finding matching variant...", element);

      // OPTIMIZED: Use helper instead of fetch
      const product = await getProductData(handle);
      console.log("📦 Product data:", product);
      console.log("📋 Available variants:", product.variants);

      var selectedOption = [];
      element
        .querySelectorAll('input[type="radio"]:checked')
        .forEach((radio) => {
          selectedOption.push(radio.value);
        });
      console.log("✅ Selected options:", selectedOption);

      // Get currently selected quantity from quantity selector
      const buyBox = document.getElementById("buy-box");
      let selectedQuantity = 1; // Default to 1 bottle
      let bottleText = "1 Bottle";

      if (buyBox && window.Alpine) {
        const quantityData = Alpine.$data(buyBox);
        if (quantityData && quantityData.selectedQuantity) {
          selectedQuantity = quantityData.selectedQuantity;
          bottleText =
            selectedQuantity === 1 ? "1 Bottle" : `${selectedQuantity} Bottles`;
        }
      }
      console.log(
        "📦 Selected quantity:",
        selectedQuantity,
        "Bottle text:",
        bottleText,
      );

      var matchedVariant = product.variants.find((variant) => {
        console.log(`\n🔎 Checking variant:`, {
          id: variant.id,
          title: variant.title,
          options: variant.options,
        });

        // Match variant based on BOTH color (options[0]) AND bottle quantity (options[1])
        // Check bottle quantity FIRST
        if (variant.options[1] !== bottleText) {
          console.log(
            `  ❌ Option 1 is "${variant.options[1]}", not "${bottleText}", skipping variant`,
          );
          return false;
        }

        // Then check color match
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          var optionValue = variant.options[i];
          var isInSelected = selectedOption.indexOf(optionValue) !== -1;

          console.log(`  Option ${i}: "${optionValue}"`, {
            inSelected: isInSelected,
            selectedOptions: selectedOption,
          });

          if (!isInSelected) {
            pass = false;
            console.log(`  ❌ Mismatch at option ${i}, skipping variant`);
            break;
          }
        }

        if (pass) {
          console.log(`  ✅ All options match!`);
        }

        return pass;
      });

      console.log("\n🎯 Matched variant:", matchedVariant);

      if (matchedVariant) {
        // Access the mainProduct component to update its price
        const mainProductElement = document.querySelector(
          '[data-section-type="main-product-new"]',
        );
        const mainProductData = mainProductElement
          ? Alpine.$data(mainProductElement)
          : null;

        if (mainProductData) {
          // Update price properties - keep as number for convertPrice function
          // Direct assignment should trigger Alpine reactivity
          const newPrice = Number(matchedVariant.price);
          const newComparePrice = Number(matchedVariant.compare_at_price || 0);

          mainProductData.currentVariantId = Number(matchedVariant.id);
          mainProductData.currentVariantTitle = matchedVariant.title;
          mainProductData.currentVariantPrice = newPrice;
          mainProductData.currentVariantCompareAtPrice = newComparePrice;

          // Trigger Alpine reactivity by dispatching a custom event
          // This ensures any watchers or computed properties are updated
          if (mainProductElement) {
            mainProductElement.dispatchEvent(
              new CustomEvent("variant-price-updated", {
                detail: {
                  price: newPrice,
                  comparePrice: newComparePrice,
                  variantId: Number(matchedVariant.id),
                },
                bubbles: true,
              }),
            );
          }
        }

        // Update the price display elements directly (all matching selectors)
        const priceEls = document.querySelectorAll(".js-main-price-display");
        const compareEls = document.querySelectorAll(
          ".js-compare-price-display",
        );

        if (priceEls.length) {
          // Get Shopify money format for proper currency formatting
          const moneyFormat = window.shopMoneyFormat;

          // Multiply variant price (in cents) by quantity, then format using Shopify
          const totalPriceCents = matchedVariant.price * selectedQuantity;
          const priceText = formatMoney(totalPriceCents, moneyFormat);

          // Update all price elements
          priceEls.forEach((el) => {
            el.innerText = priceText;
          });

          // Update compare price if available
          if (matchedVariant.compare_at_price > 0) {
            const totalCompareCents =
              matchedVariant.compare_at_price * selectedQuantity;
            const compareText = formatMoney(totalCompareCents, moneyFormat);
            compareEls.forEach((el) => {
              el.innerText = compareText;
              el.classList.remove("hidden");
            });
          } else {
            compareEls.forEach((el) => el.classList.add("hidden"));
          }
        }

        this.currentVariantId = Number(matchedVariant.id);
        this.currentVariantTitle = matchedVariant.title;
        this.currentVariantPrice = matchedVariant.price;
        this.currentVariantCompareAtPrice = matchedVariant.compare_at_price;

        this.fetchGallery();
        this.updateSliderImages(matchedVariant.id);
        this.updateTheThreeProducts(this.currentVariantTitle);
        this.updateSticky(this.currentVariantTitle);

        // Sync color dropdown in sticky ATC
        const colorValue = matchedVariant.options[0]; // First option is color
        this.syncStickyColorDropdown(colorValue);
      } else {
      }

      setTimeout(() => {
        this.initSlider();
      }, 200);
    },
  }));

  Alpine.data("productOptionsFromProductSelector", (el, handle) => ({
    init() {},

    async findMatchingVariantFromProductSelector(selectorIndex) {
      // OPTIMIZED: Use helper instead of fetch
      const product = await getProductData(handle);

      var selectedOption = [];
      el.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
        selectedOption.push(radio.value);
      });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      if (!matchedVariant) return;

      if (selectorIndex === 1) {
        this.productOne.id = matchedVariant.id;
        this.productOne.price = matchedVariant.price;
        this.productOne.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 2) {
        this.productTwo.id = matchedVariant.id;
        this.productTwo.price = matchedVariant.price;
        this.productTwo.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 3) {
        this.productThree.id = matchedVariant.id;
        this.productThree.price = matchedVariant.price;
        this.productThree.compareAtPrice = matchedVariant.compare_at_price;
      }

      this.updateTotalPrice();

      console.log(matchedVariant.price);
    },
  }));

  Alpine.data("productOptionsFromSticky", (el, handle) => ({
    async handleOptionClickSticky(value) {
      // if (Alpine.store("sync").isSyncing) return;

      Alpine.store("sync").isSyncing = true;

      const checkbox = document.querySelector(
        `#product_options input[value="${value}"]`,
      );
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      Alpine.store("sync").isSyncing = false;
    },
  }));
});
